import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PrescriptionRenewalModal from './PrescriptionRenewalModal';
import PrescriptionRenewalViewModel from './viewModel';
import {
  PrescriptionRenewalCard,
  PrescriptionRenewalTitle,
  PrescriptionRenewalInfoRow,
  PrescriptionRenewalInfoIcon,
  PrescriptionRenewalInfoText,
  PrescriptionRenewalRequestButton,
  PrescriptionRenewalLoading
} from './styled';

export default function PrescriptionRenewalView() {
  const { isModalOpen, handleOpenModal, handleCloseModal, isListing, hasPendingRequest, handleOrderCreated } =
    PrescriptionRenewalViewModel();

  if (isListing) {
    return <PrescriptionRenewalLoading variant="indeterminate" />;
  }

  return (
    <>
      {hasPendingRequest ? (
        <PrescriptionRenewalCard>
          <PrescriptionRenewalInfoRow>
            <PrescriptionRenewalInfoIcon />
            <PrescriptionRenewalInfoText>
              Você já possui uma solicitação de renovação em andamento. Aguarde o retorno da médica para poder fazer um novo
              pedido.
            </PrescriptionRenewalInfoText>
          </PrescriptionRenewalInfoRow>
          <PrescriptionRenewalRequestButton variant="contained" color="primary" endIcon={<ArrowForwardIcon />} disabled>
            Solicitar renovação de pedido
          </PrescriptionRenewalRequestButton>
        </PrescriptionRenewalCard>
      ) : (
        <PrescriptionRenewalCard>
          <PrescriptionRenewalTitle>Precisa renovar um pedido de exame ou medicamento?</PrescriptionRenewalTitle>
          <Button variant="contained" color="primary" endIcon={<ArrowForwardIcon />} onClick={handleOpenModal}>
            Solicitar renovação de pedido
          </Button>
        </PrescriptionRenewalCard>
      )}
      <PrescriptionRenewalModal open={isModalOpen} onClose={handleCloseModal} onOrderCreated={handleOrderCreated} />
    </>
  );
}
